import styled from 'styled-components';

const StyledImage = styled.img`
  width: ${(props) => (props.width ? props.width : 40)}px;
`;

export default StyledImage;
